<template>
  <v-layout>
    <v-flex>
      <v-card class="totals-box">
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-3">{{ headerDate }}</h3>
            <div>
              <p><strong>Total:</strong> {{totals_data.total_count}} / {{currencyToLocal(totals_data.total_value)}}</p>
              <p class="item"><strong>Consultando chave:</strong> {{totals_data.checking_pix_key.total_count}} / {{currencyToLocal(totals_data.checking_pix_key.total_value)}}</p>
              <p class="sub-item"><strong>Waiting:</strong> {{totals_data.checking_pix_key.waiting.total_count}} / {{currencyToLocal(totals_data.checking_pix_key.waiting.total_value)}}</p>
              <p class="sub-item"><strong>Processing:</strong> {{totals_data.checking_pix_key.processing.total_count}} / {{currencyToLocal(totals_data.checking_pix_key.processing.total_value)}}</p>
              <p class="sub-item"><strong>Failed:</strong> {{totals_data.checking_pix_key.failed.total_count}} / {{currencyToLocal(totals_data.checking_pix_key.failed.total_value)}}</p>
              <p class="item"><strong>Enviando:</strong> {{totals_data.sending_pix.total_count}} / {{currencyToLocal(totals_data.sending_pix.total_value)}}</p>
              <p class="sub-item"><strong>Waiting:</strong> {{totals_data.sending_pix.waiting.total_count}} / {{currencyToLocal(totals_data.sending_pix.waiting.total_value)}}</p>
              <p class="sub-item"><strong>Processing:</strong> {{totals_data.sending_pix.processing.total_count}} / {{currencyToLocal(totals_data.sending_pix.processing.total_value)}}</p>
              <p class="sub-item"><strong>Failed:</strong> {{totals_data.sending_pix.failed.total_count}} / {{currencyToLocal(totals_data.sending_pix.failed.total_value)}}</p>
              <p class="item"><strong>Confirmando:</strong> {{totals_data.checking_pix.total_count}} / {{currencyToLocal(totals_data.checking_pix.total_value)}}</p>
              <p class="sub-item"><strong>Waiting:</strong> {{totals_data.checking_pix.waiting.total_count}} / {{currencyToLocal(totals_data.checking_pix.waiting.total_value)}}</p>
              <p class="sub-item"><strong>Processing:</strong> {{totals_data.checking_pix.processing.total_count}} / {{currencyToLocal(totals_data.checking_pix.processing.total_value)}}</p>
              <p class="item"><strong>Finalizado:</strong> {{totals_data.done.total_count}} / {{currencyToLocal(totals_data.done.total_value)}}</p>
              <p class="sub-item"><strong>Succeed:</strong> {{totals_data.done.succeed.total_count}} / {{currencyToLocal(totals_data.done.succeed.total_value)}}</p>
              <p class="sub-item"><strong>Failed:</strong> {{totals_data.done.failed.total_count}} / {{currencyToLocal(totals_data.done.failed.total_value)}}</p>
            </div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn flat color="green" @click="removeDate">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import utils from "../shared/Utils";

  export default {
    name: 'PixWiresTotals',
    props: {
      pickedDate: {
        type: String,
        default: "01/01/1970"
      }
    },
    data () {
      return {
        loading: false,
        steps: { 0: "none", 1: "checking_pix_key", 2: "sending_pix", 3: "checking_pix", 4: "done" },
        statuses: { 0: "none", 1: "processing", 2: "waiting", 3: "failed", 4: "succeed" },
        totals_data: {
          total_count: 0,
          total_value: 0.0,
          checking_pix_key: {
            total_count: 0,
            total_value: 0.0,
            processing: {
              total_count: 0,
              total_value: 0.0
            },
            waiting: {
              total_count: 0,
              total_value: 0.0
            },
            failed: {
              total_count: 0,
              total_value: 0.0
            },
          },
          sending_pix: {
            total_count: 0,
            total_value: 0.0,
            processing: {
              total_count: 0,
              total_value: 0.0
            },
            waiting: {
              total_count: 0,
              total_value: 0.0
            },
            failed: {
              total_count: 0,
              total_value: 0.0
            }
          },
          checking_pix: {
            total_count: 0,
            total_value: 0.0,
            processing: {
              total_count: 0,
              total_value: 0.0
            },
            waiting: {
              total_count: 0,
              total_value: 0.0
            },
            failed: {
              total_count: 0,
              total_value: 0.0
            }
          },
          done: {
            total_count: 0,
            total_value: 0.0,
            failed: {
              total_count: 0,
              total_value: 0.0
            },
            succeed: {
              total_count: 0,
              total_value: 0.0
            }
          }
        }
      }
    },
    computed: {
      headerDate() {
        return utils.dbDateToHuman(this.pickedDate)
      },
    },
    methods: {
      removeDate() {
        this.$emit('onRemove', this.pickedDate)
      },
      currencyToLocal(value) {
        return utils.currencyToLocal(value, 'BRL')
      },
      updateState(data) {
        let from_step = this.steps[data.args[0]]
        let from_status = this.statuses[data.args[1]]
        let to_step = this.steps[data.args[2]]
        let to_status = this.statuses[data.args[3]]
        let value = Number(data.args[4])

        let totals_data = {...this.totals_data}

        if (from_step === 'none') {
          totals_data.total_count += 1
          totals_data.total_value = Number(totals_data.total_value) + value
        } else {
          totals_data[from_step][from_status].total_count -= 1
          totals_data[from_step][from_status].total_value = Number(totals_data[from_step][from_status].total_value) - value
          totals_data[from_step].total_count -= 1
          totals_data[from_step].total_value = Number(totals_data[from_step].total_value) - value
        }
        totals_data[to_step][to_status].total_count += 1
        totals_data[to_step][to_status].total_value = Number(totals_data[to_step][to_status].total_value) + value
        totals_data[to_step].total_count += 1
        totals_data[to_step].total_value = Number(totals_data[to_step].total_value) + value

        this.totals_data = totals_data
      },
      replaceState(data) {
        this.totals_data = data
      }
    },
    mounted() {
      const events = [
        {
          name: 'update_state', 
          action: app => {
            return payload => {
              app.$emit(`update_state_${this.pickedDate}`, payload)
            }
          }
        },
        {
          name: 'replace_state', 
          action: app => {
            return payload => {
              app.$emit(`replace_state_${this.pickedDate}`, payload)
            }
          }
        }
      ]
      this.$root.store.connectToChannel(`company_wire:${this.pickedDate}`, events)
      this.$root.$on(`replace_state_${this.pickedDate}`, (data) => { this.totals_data = data })
      this.$root.$on(`update_state_${this.pickedDate}`, (data) => { this.updateState(data) })
    },
    beforeDestroy() {
      this.$root.$off(`replace_state_${this.pickedDate}`);
      this.$root.$off(`update_state_${this.pickedDate}`);
      this.$root.store.disconnectFromChannel(`company_wire:${this.pickedDate}`)
    }
  }
</script>

<style scoped>
  .totals-box {
    line-height: 0.3;
  }
  .item {
    padding-top: 10px;
  }
  .sub-item {
    text-align: right;
  }

</style>


// WEBPACK FOOTER //
// src/components/PixWiresTotals.vue